import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Button } from 'tdesign-react';
import { ReactComponent as MaintenanceIcon } from './assets-result-maintenance.svg';

export default function ErrorPage502() {
  const navigate = useNavigate();

  const goHome = () => {
    navigate('/login');
  };

  return (
    <Root>
      <MaintenanceIcon size={72} color='var(--td-brand-color)' />
      <Title>系统维护中</Title>
      <Description>系统维护中，请稍后再试。</Description>
      <Footer>
        <Button onClick={goHome}>返回登录</Button>
      </Footer>
    </Root>
  );
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: rgb(238, 238, 238);
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 28px;
  margin-top: 28px;
  color: var(--td-text-color-primary);
`;

const Description = styled.div`
  margin: 8px 0 32px;
  font-size: 14px;
  line-height: 22px;
  color: var(--td-text-color-secondary);
`;

const Footer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  color: var(--td-text-color-secondary);
`;
